import typeToReducer from 'type-to-reducer';
import { combineReducers } from 'redux';
import { loadingStateReducer } from '../utils';

import { LOAD_MACHINE_METRICS_ALARM_HISTORY } from './constants';

export default combineReducers({
  loadingState: loadingStateReducer([LOAD_MACHINE_METRICS_ALARM_HISTORY]),
  data: typeToReducer(
    {
      [LOAD_MACHINE_METRICS_ALARM_HISTORY]: {
        SUCCESS: (state, { payload }) => payload
      }
    },
    []
  )
});
